export default __webpack_public_path__ + "static/media/twitch.579b8c47.svg";